import { createStyles } from '@mantine/styles';

var useStyles = createStyles(() => ({
  base: {
    display: "flex",
    alignItems: "center",
    overflow: "hidden"
  }
}));

export default useStyles;
//# sourceMappingURL=Machine.styles.js.map
